<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="80px">
        <el-form-item label="门店名称">
          <el-input
            placeholder="请输入"
            v-model="searchData.storeName"
            clearable
            size="small"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            placeholder="请输入"
            v-model="searchData.orderNo"
            clearable
            class="input-with-select"
            size="small"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="结算时间">
          <el-date-picker
            style="width: 300px"
            v-model="searchData.settleDate"
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结算状态">
          <el-select
            v-model="searchData.settleStatus"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="item in SettleStatusList"
              :label="item.name"
              :value="item.value"
              :key="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式">
          <el-select
            v-model="searchData.settleType"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="item in SettleTypeList"
              :label="item.name"
              :value="item.value"
              :key="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="search"
            >搜索</el-button
          >
          <el-button
            type="info"
            size="small"
            icon="el-icon-refresh"
            @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <div class="header-btn">
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.finance_store_settle_export)"
        style="margin-bottom: 20px"
        type="primary"
        icon="el-icon-download"
        size="small"
        @click="downloadExcel"
        >导出</el-button
      >
    </div>

    <tp-table
      :isNeedSerialNumber="true"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <!-- 打款结算 -->
    <SettleDialog
      :orderNo="row.orderNo"
      :visible.sync="row.visible"
      :settleType="row.settleType"
      @ok="ok"
    />

    <!-- 撤回打款 -->
    <ConfirmRevoke
      :visible.sync="confirm.visible"
      :title="confirm.title"
      :orderNo="confirm.orderNo"
      :onOk="confirm.onOk"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
  getStoreSettleListAPI,
  exportAPI,
  revokeAlipayTransferAPI,
  downloadReceiptAPI,
  downloadReceiptPdf,
} from "./api";
import SettleDialog from "./settle-dialog.vue";
import ConfirmRevoke from "@/views/finance/store/settle/confirm-revoke.vue";
import { dateFormat } from "@/utils";
import {
  getWithholdChannelText,
  getWithholdChannelType,
  shouldShowWithholdChannel,
} from "@/enum/dict/withholdChannel";
import {SettleStatusList, getSettleStatusStyle, SettleTypeList} from "@/enum/dict/settle";

const columns = [
  {
    label: "门店名称",
    prop: "storeName",
    minWidth: "220",
    customRender(h, row) {
      return <p>{row["storeName"]}</p>;
    },
  },
  {
    label: "客户姓名",
    prop: "memberName",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["memberName"]}</p>;
    },
  },
  {
    label: "订单信息",
    prop: "orderNo",
    minWidth: "260",
    customRender(h, row) {
      return (
        <div>
          <div>订单号：{row["orderNo"]}</div>
          <div>
            订单类型：
            <el-tag v-show={row["orderType"] == 2} type="warning" size="mini">
              门店订单
            </el-tag>
            <el-tag
              v-show={row["orderType"] == 4}
              color="#ffcccc54"
              style="color:#ff7744;border-color:#ffcccc54"
              size="mini"
            >
              电车订单
            </el-tag>

            <el-tag
                v-show={shouldShowWithholdChannel(row["withholdChannel"])}
                type={getWithholdChannelType(row["withholdChannel"])}
                size="mini"
                style="margin-left: 5px"
            >
              {getWithholdChannelText(row["withholdChannel"])}
            </el-tag>
          </div>
          <div>订单状态：{row["orderStatusName"]}</div>
          <div>下单时间：{row["orderCreateTime"]}</div>
        </div>
      );
    },
  },
  {
    label: "商品信息",
    prop: "goodsTitle",
    minWidth: "180",
    customRender(h, row) {
      return <p class="goods-info">{row["goodsTitle"]}</p>;
    },
  },
  {
    label: "商户",
    prop: "merchantName",
    minWidth: "180",
    customRender(h, row) {
      return <p>{row.merchantName}</p>;
    },
  },
  {
    label: "结算方式",
    prop: "settleTypeName",
    minWidth: "130",
    customRender(h, row) {
      return <p>{row.settleTypeName}</p>;
    },
  },
  {
    label: "收款账户信息",
    prop: "payeeAlipayAccount",
    minWidth: "220",
    customRender(h, row) {
      if (row.settleType === 1) {
        return <div>-</div>;
      }

      return (
        <div>
          <p>姓名：{row["payeeIdName"]}</p>
          <p>支付宝账号：{row["payeeAlipayAccount"]}</p>
        </div>
      );
    },
  },
  {
    label: "结算金额",
    minWidth: "100",
    prop: "settleAmount",
    customRender(h, row) {
      return <p>￥{row["settleAmount"]}</p>;
    },
  },
  {
    label: "结算时间",
    prop: "settleTime",
    minWidth: "160",
    customRender(h, row) {
      return <p>{row.settleTime}</p>;
    },
  },
  {
    label: "结算状态",
    prop: "settleStatusName",
    minWidth: "120",
    fixed: "right",
    customRender(h, row) {
      return (
        <p>
          <span style={getSettleStatusStyle(row["settleStatus"])}>
            {row["settleStatusName"]}
          </span>
        </p>
      );
    },
  },
  {
    label: "操作",
    minWidth: "200",
    fixed: "right",
    align: "center",
    customRender(h, row) {
      return (
        <div>
          <el-link
            style="margin-right:10px"
            v-show={
                this.showAlipayTransferBtn(row) &&
                this.isShowBtn(this.AUTH_BTN.finance_store_settle_alipay_payment)
            }
            underline={false}
            type="primary"
            onClick={() => this.showSettleDialog(row, 2)}
          >
            吱口令打款
          </el-link>

          <el-link
            style="margin-right:10px"
            v-show={
                this.showAlipayRevokeBtn(row) &&
                this.isShowBtn(this.AUTH_BTN.finance_store_settle_alipay_revoke)
            }
            underline={false}
            type="primary"
            onClick={() => this.handleAlipayRevoke(row["orderNo"])}
          >
            撤回打款
          </el-link>

          <el-link
            style="margin-right:10px"
            v-show={
              this.showOfflinePayBtn(row) &&
              this.isShowBtn(this.AUTH_BTN.finance_store_settle_offline_payment)
            }
            underline={false}
            type="primary"
            onClick={() => this.showSettleDialog(row, 1)}
          >
            线下打款
          </el-link>
        </div>
      );
    },
  },
];

export default {
  name: "FinanceStoreSettle",
  mixins: [authBtnMixin],
  components: {
    SettleDialog,
    ConfirmRevoke,
  },
  data() {
    return {
      SettleStatusList,
      SettleTypeList,
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        storeName: "", //门店名称
        orderNo: "", //订单号
        settleDate: "", //结算日期
        settleStatus: "", //结算状态
        settleType: "", //结算方式
      },
      row: {},
      confirm: {
        visible: false,
        orderNo: null,
        title: null,
        onOk: null,
      },
      enableOperationOrderStatusList: [6, 7, 8, 91],
      alipayTransferSettleStatusList: [0, 1, 2],
      offlineTransferSettleStatusList: [0, 2, 5],
    };
  },

  mounted() {
    this.getList();
  },

  watch: {
    currentPage() {
      this.getList();
    },

    pageSize() {
      this.getList();
    },
  },

  methods: {
    search() {
      this.getList();
    },

    async getList() {
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchData,
      };
      if (this.searchData.settleDate && this.searchData.settleDate.length > 0) {
        params.leftSettleDate = this.searchData.settleDate[0];
        params.rightSettleDate = this.searchData.settleDate[1];
        params.settleDate = "";
      }
      const res = await getStoreSettleListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },

    downloadExcel() {
      let params = { ...this.searchData };
      if (this.searchData.settleDate && this.searchData.settleDate.length > 0) {
        params.leftSettleDate = this.searchData.settleDate[0];
        params.rightSettleDate = this.searchData.settleDate[1];
        params.settleDate = "";
      }
      exportAPI(params);
    },

    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },

    ok() {
      this.row.visible = false;
      this.getList();
    },

    alipayTransferSuccess(row) {
      return (
        row.settleType === 2 && row.settleStatus === 3 && !this.ifOverTime(row)
      );
    },

    //吱口令按钮展示条件
    showAlipayTransferBtn(row) {
      return this.enableOperationOrderStatusList.includes(row.orderStatus)
          && row.settleType === 2 && this.alipayTransferSettleStatusList.includes(row.settleStatus);
    },

    //撤回打款按钮展示条件
    showAlipayRevokeBtn(row) {
      return this.enableOperationOrderStatusList.includes(row.orderStatus)
          && row.settleType === 2 && row.settleStatus === 1;
    },

    //线下打款按钮展示条件
    showOfflinePayBtn(row) {
      return this.enableOperationOrderStatusList.includes(row.orderStatus)
          && this.offlineTransferSettleStatusList.includes(row.settleStatus);
    },

    ifOverTime(row) {
      if (!row.settleTime) {
        return false;
      }
      const duration = dayjs().diff(dayjs(row.settleTime), "day");
      return duration > 365;
    },

    showSettleDialog(row, settleType) {
      this.row = {
        orderNo: row.orderNo,
        visible: true,
        settleType,
      };
    },

    handleAlipayRevoke(orderNo) {
      this.$set(this, "confirm", {
        title: "撤回吱口令打款后，该笔结算只能通过线下打款",
        visible: true,
        orderNo,
        onOk: async () => {
          await revokeAlipayTransferAPI({orderNo});
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        },
      });
    },

    async downloadReceipt(row) {
      const res = await downloadReceiptAPI({ orderNo: row.orderNo });
      downloadReceiptPdf(
        res.receiptFileUrl,
        `结算回单${row.orderNo}-${dateFormat()}.pdf`,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.mr20 {
  margin-right: 20px;
}
.wrapper {
  width: 100%;
  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 35px;
        .el-input {
          width: 200px;
        }
        .el-select {
          width: 200px;
        }
        .el-date-editor {
          width: 200px;
          /deep/.el-range-separator {
            width: auto;
          }
        }
      }
    }
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  .header-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
  .goods-info {
    display: flex;
  }
  /deep/ .el-dialog__body {
    padding-top: 10px;
  }
}
</style>
